module.exports = __webpack_public_path__ + "media/images/arrow-537d5e824b8c583c71e5ca2411c52a57.png";